
import React, { useState, useEffect } from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import TelemetryDashboard from '@/components/TelemetryDashboard';
import { mockTelemetryData as energyTelemetryData } from '@/lib/mock-data/energy/telemetry';
import { mockTelemetryData as gasTelemetryData } from '@/lib/mock-data/gas/telemetry';
import { mockTelemetryData as waterTelemetryData } from '@/lib/mock-data/water/telemetry';
import { Device } from './gis-map/types';
import { useToast } from '@/hooks/use-toast';

interface DeviceTelemetryTabProps {
  deviceType?: 'energy' | 'gas' | 'water';
  selectedDeviceId?: string;
  selectedDeviceType?: string;
  deviceData?: Device | null;
}

const DeviceTelemetryTab: React.FC<DeviceTelemetryTabProps> = ({ 
  deviceType = 'energy',
  selectedDeviceId,
  selectedDeviceType,
  deviceData
}) => {
  // Track the selected card section for highlighting
  const [selectedSection, setSelectedSection] = useState<string | null>(null);
  const { toast } = useToast();
  
  // Select the appropriate telemetry data based on device type
  const getTelemetryData = () => {
    switch (deviceType) {
      case 'gas':
        return gasTelemetryData;
      case 'water':
        return waterTelemetryData;
      default:
        return energyTelemetryData;
    }
  };

  // Show toast when device data is available
  useEffect(() => {
    if (deviceData && selectedDeviceId) {
      toast({
        title: "Telemetry Data Loaded",
        description: `Viewing telemetry for ${deviceData.name} (${selectedDeviceId})`,
      });
    }
  }, [deviceData, selectedDeviceId, toast]);

  // Log the device data for debugging
  useEffect(() => {
    if (deviceData) {
      console.log('Device data in telemetry tab:', deviceData);
    }
  }, [deviceData]);

  return (
    <div className="h-full overflow-auto">
      <AnimatedCard
        animation="fade-up"
        delay={100}
        className="border-none shadow-sm"
      >
        <TelemetryDashboard 
          telemetryData={getTelemetryData()} 
          isLoading={false} 
          telemetryType={deviceType}
          selectedSection={selectedSection}
          onCardClick={setSelectedSection}
          deviceId={selectedDeviceId}
          deviceData={deviceData}
        />
      </AnimatedCard>
    </div>
  );
};

export default DeviceTelemetryTab;
